// extracted by mini-css-extract-plugin
export var input = "file-input-area-module--input--5JjN+";
export var label = "file-input-area-module--label--R6fQC";